<template>
  <component :is="props.tag" class="d-flex flex-column">
    <h3 @click="showContent = !showContent" class="cursor-pointer w-fit" :class="{ 'text-danger': props.error }">
      {{ props.name }}
      <IconChevronDown :size="20" class="dropdown-icon" :class="{ 'flip-icon': showContent }" />
    </h3>
    <slot name="description" :isOpened="showContent" />
    <div class="animate__animated animate__fadeIn animate__slow" style="z-index: 2" v-show="showContent">
      <slot />
    </div>
  </component>
</template>
<script setup lang="ts">
import { IconChevronDown } from '@tabler/icons-vue';

const showContent = defineModel<boolean>({ required: true });
const props = withDefaults(defineProps<{ name: string; tag?: string; error?: boolean }>(), {
  tag: 'div',
  error: false,
});
</script>
<style scoped>
.dropdown-icon {
  transition: transform 0.3s ease;
  margin-left: 0.5rem;
}

.dropdown-icon.flip-icon {
  transform: rotate(180deg);
}
</style>
